import { Box, Grid } from '@material-ui/core';
import ChevronCardButton from 'components/ChevronCardButton';
import { SmallSectionHeader } from 'components/Typography';
import { StyledShortBody } from 'containers/MRhDashboard/services/styles';
import messages from 'containers/MRhDashboard/messages';
import { translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import { sanlamDarkGrayishBlue } from 'Material-UI/colors';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import PAGES from 'routes/pages';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const Services = (props: { intl: IntlShape; position?: any }) => {
  const item = {
    title: (
      <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
        {translate(messages.contactAgent, props)}
      </StyledShortBody>
    ),
    icon: 'agent',
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box paddingRight={2}>
      <Grid container>
        <Grid xs={12} item>
          <SmallSectionHeader>
            {translate(messages.myServices, props)}
          </SmallSectionHeader>
        </Grid>
        <Grid xs={matches ? 12 : props.position} item>
          <ChevronCardButton
            clickHandler={() => pushTo(PAGES.AGENT)}
            item={item}
            deleteHoverBorder={true}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default injectIntl(Services);
